import { createContext, useContext } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const RECAPTCHA_SCRIPT_PROPS = { defer: true }

const InRecaptchaScopeContext = createContext(false)

// Loads Google's reCAPTCHA script for everything below it. A nested scope reuses the outer one: a second
// provider would remove the shared script when it unmounts. Wrap a multi-step flow high up so the script
// is ready by the time the sign-up step submits.
export default function RecaptchaScope({ children }: { children: React.ReactNode }): React.ReactElement {
  const isInScope = useContext(InRecaptchaScopeContext)

  if (isInScope) {
    return <>{children}</>
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? ''}
      scriptProps={RECAPTCHA_SCRIPT_PROPS}
    >
      <InRecaptchaScopeContext.Provider value>{children}</InRecaptchaScopeContext.Provider>
    </GoogleReCaptchaProvider>
  )
}
